import { extractDateTimeStamp } from '../utils/date-timestamp-extraction';

export interface RecordingTimings {
  addedToQueue: Date | null;
  analysisCompleted: Date | null;
  backendRecived: Date | null;
  completionDate: Date | null;
  sentToInstance: Date | null;
  uploadComplete: Date | null; // iOS
  uploadStart: Date | null; // iOS
}

export class RecordingTimingsClass implements RecordingTimings {
  addedToQueue: Date | null;
  analysisCompleted: Date | null;
  backendRecived: Date | null;
  completionDate: Date | null;
  sentToInstance: Date | null;
  uploadComplete: Date | null;
  uploadStart: Date | null;

  constructor(o: any = {}) {
    this.addedToQueue = extractDateTimeStamp(o['addedToQueue']);
    this.analysisCompleted = extractDateTimeStamp(o['analysisCompleted']);
    this.backendRecived = extractDateTimeStamp(o['backendRecived']);
    this.completionDate = extractDateTimeStamp(o['completionDate']);
    this.sentToInstance = extractDateTimeStamp(o['sentToInstance']);
    this.uploadComplete = extractDateTimeStamp(o['uploadComplete']);
    this.uploadStart = extractDateTimeStamp(o['uploadStart']);
  }
}
